import styled from 'styled-components';
import TaskGroup from './component';

export default styled(TaskGroup)`
  background-color: white;
  border-radius: 2px;
  margin-bottom: 8px;
  cursor: pointer;

  .girded-exclamation svg {
    width: 16px;
    & path {
      fill: #cd7300;
    }
  }

  .header {
    min-height: 24px;
    padding: 0 8px;
    display: flex;
    flex-direction: column;
    gap: 2px;
    background-color: var(--grey300);
    border-radius: 2px 2px 0 0;

    &--selected {
      background-color: var(--primary200);
    }

    &--open {
      background-color: var(--primary300);
    }
    &__container {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &__group {
      max-width: 172px;
      display: flex;
      margin-right: 4px;
      margin-top: 1px;

      &__owner {
        margin-right: 8px;
      }

      &__id {
        margin-right: 8px;
      }
    }
    &__next-tag {
      margin-left: 4px;
    }
    &__driver-info {
      display: flex;
      gap: 5px;
      align-items: center;
      justify-content: flex-start;
      &__name {
        text-transform: capitalize;
      }
    }
  }
`;
